/**
 * CDN工具函数
 * 用于处理静态资源的CDN路径
 */

// CDN基础URL
const CDN_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://cdn.zz-zetok.com' 
  : '';

/**
 * 获取CDN资源路径
 * @param {string} path - 资源路径
 * @returns {string} CDN完整路径
 */
export function getCdnUrl(path) {
  if (!path) return '';
  
  // 如果已经是完整URL，直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // 如果路径已经包含CDN域名，直接返回
  if (path.includes('cdn.zz-zetok.com')) {
    return path;
  }
  
  // 排除Element UI相关资源，保持原有路径
  if (path.includes('element-ui') || path.includes('theme-chalk')) {
    return path;
  }
  
  // 移除开头的斜杠
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // 确保CDN_BASE_URL不以斜杠结尾，path不以斜杠开头
  return `${CDN_BASE_URL}/${cleanPath}`;
}

/**
 * 获取图片CDN路径
 * @param {string} imagePath - 图片路径
 * @returns {string} 图片CDN完整路径
 */
export function getImageUrl(imagePath) {
  return getCdnUrl(imagePath);
}

/**
 * 获取视频CDN路径
 * @param {string} videoPath - 视频路径
 * @returns {string} 视频CDN完整路径
 */
export function getVideoUrl(videoPath) {
  return getCdnUrl(videoPath);
}

/**
 * 获取字体CDN路径
 * @param {string} fontPath - 字体路径
 * @returns {string} 字体CDN完整路径
 */
export function getFontUrl(fontPath) {
  return getCdnUrl(fontPath);
}

/**
 * 批量处理对象中的资源路径
 * @param {Object} obj - 包含资源路径的对象
 * @returns {Object} 处理后的对象
 */
export function processCdnUrls(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  
  const processed = {};
  
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' && (value.includes('.jpg') || value.includes('.png') || value.includes('.webp') || value.includes('.gif') || value.includes('.mp4') || value.includes('.otf') || value.includes('.ttf'))) {
      processed[key] = getCdnUrl(value);
    } else if (typeof value === 'object' && value !== null) {
      processed[key] = processCdnUrls(value);
    } else {
      processed[key] = value;
    }
  }
  
  return processed;
}

// 默认导出
export default {
  getCdnUrl,
  getImageUrl,
  getVideoUrl,
  getFontUrl,
  processCdnUrls
};